import axios from 'axios'
import size from '../modules/size'

const apiResultsElement = document.querySelector('.api-results')
const instituteElement = document.querySelector('.institute')
const instituteContentElement = document.querySelector('.institute__content')
const instituteLoadingElement = document.querySelector('#loadin-institute')
const bodyElement = document.querySelector('body')
const loadMoreBtn = document.querySelector('.api-results__load-more')
const closeInstituteBtn = document.querySelector('.institute__close')
const footerElement = document.querySelector('.footer')
let instituteCodeGlobal 

axios.defaults.withCredentials = true;

siteData.addPref = instituteCode => {
  console.log(this)
  axios.post(`http://api.bat-ami.org.il/Api/MyData/MyPreferredInstituteAdd/${instituteCode}`)
    .then(result => {
      console.log('res', result)
      let add = document.querySelector(".add-pref")
      let del = document.querySelector(".del-pref")
      let instName = document.querySelector(".institute__name")
      add.classList.add("hide")
      del.classList.add("show")
      instName.classList.add("pref")
    })
.catch(err => console.error(err))

return false;
}
siteData.delPref = instituteCode => {
  console.log(this)
  axios.post(`http://api.bat-ami.org.il/Api/MyData/MyPreferredInstituteDelete/${instituteCode}`)
    .then(result => {
      console.log('res', result)
      let add = document.querySelector(".add-pref")
      let del = document.querySelector(".del-pref")
      let instName = document.querySelector(".institute__name")
      add.classList.remove("hide")
      del.classList.remove("show")
      instName.classList.remove("pref")
    })
.catch(err => console.error(err))

return false;
}

export const fetchInstituteData = instituteCode => {

  //const proxy = location.host.includes('local') || location.host.includes('upress') || location.host.includes('vangus') ? 'https://cors-anywhere.herokuapp.com/' : ''//
  const proxy = ''// 'https://cors-anywhere.herokuapp.com/'

  handelModalPosition()
  handlePresentation()
  addInstituteCodeToUrl(instituteCode)

  instituteContentElement.innerHTML = ''
  instituteLoadingElement.classList.add('loading--active')

  axios.all([
    axios.get(`${proxy}http://api.bat-ami.org.il/Api/Search/GetInstituteDetails`, {
      params: {
        id: instituteCode
      }
    }), 
    axios.get(`http://api.bat-ami.org.il/Api/MyData/IsMyPreferredInstitute/${instituteCode}`)
  ])
    .then(axios.spread((result, result2) => {
      console.log('res', result, 'result2', result2)

      let isPref = result2.data.IsSuccessful

      instituteLoadingElement.classList.remove('loading--active')
      const {
        data: {
          Name,
          CityName,
          TempText1: motivation,
          TempText2: description,
          Address,
          PostCount,
          tempText3: instruction,
          tempText4: aboutCity,
          CooName,
          CooPhone,
          CooEmail,
          CooMoto,
          hasSeed,
          isOutPosts,
          HasCooImage,
          HasInstImage,
          CooImageLink,
          InstituteImageLink,
          CategoryName,
        } } = result
      const html = `
      <div class="institute__head">
        <div class="institute__details">
          <h3 class="institute__name ${isPref ? 'pref' : ''}">${Name}</h3>
          <div class="institute__category"><span class="institute__category-txt">${CategoryName}</span><span class="institute__category-icon">
              ${hasSeed ? `<span class="api-result__seed"><img class="api-result__icon" src="/wp-content/themes/batami/img/m1.png"></span>` : ''}
              ${isOutPosts ? `<span class="api-result__apartment"><img class="api-result__icon" src="/wp-content/themes/batami/img/m3.png"></span>` : ''}
              <div class="institute__location"> <span class="institute__location-icon"><img class="api-result__icon" src="/wp-content/themes/batami/img/location.png"></span>${CityName}</div>
          </span></div>
        </div>
        <div class="institute__img-wrapper">
          <img src="${InstituteImageLink}" alt="" class="institute__img">
        </div>
      </div>
      <div class="flex space-between">
        <h3 class="institute__title">תיאור</h3>
        <div>
          <a href="#" class="add-pref ${isPref ? 'hide' : ''}" onclick="siteData.addPref('${instituteCode}')">הוספה למועדפים</a>
          <a href="#" class="del-pref ${isPref ? 'show' : ''}" onclick="siteData.delPref('${instituteCode}')">הסרה ממועדפים</a>
        </div>
      </div>
      <p class="institute__txt">${description}</p>
      <h3 class="institute__title">אנחנו רוצים אותך</h3>
      <p class="institute__txt">${motivation}</p>

      <div class="institute__info">
        <div>
          <strong>כתובת</strong>
          <span>${Address}</span>
        </div>
        <div>
          <strong>ישוב</strong>
          <span>${CityName}</span>
        </div>
        <div>
          <strong>תקנים</strong>
          <span>${PostCount}</span>
        </div>
      </div>

      <p>
        <strong>דרכי הגעה</strong>
        <span>${instruction}</span>
      </p>
      <h3 class="institute__title">על הישוב</h3>
      <p>${aboutCity}</p>
      <div class="institute__coordinator">
        <img src="${CooImageLink}" alt="" class="institute__coordinator-img">
        <div class="institute__coordinator-details">
          <p><strong>רכזת: </strong><span>${CooName}</span></p>
          <a href="tel:${CooPhone}">${CooPhone}</a>
          <a href="mailto:${CooEmail}">${CooEmail}</a>
          <i class="institute__coordinator-moto">${CooMoto ? `"${CooMoto}"` : ''}</i>
        </div>
      </div>`

      instituteContentElement.innerHTML = html

    }))
    .catch(err => console.error(err))
}

export const closeInstituteHandler = () => {
  closeInstituteBtn.addEventListener('click', e => {
    closeInstitute()
  })
}


// helpers
const handlePresentation = () => {
  apiResultsElement.style.visibility = 'hidden'
  loadMoreBtn.style.display = 'none'
  instituteElement.classList.add('institute--active')
  bodyElement.classList.add('no-scroll')

  if (!size.isMobile())
    instituteElement.style.width = `${apiResultsElement.offsetWidth}px`
}

const handelModalPosition = () => {

  if (size.isMobile())
    return

  const instituteElement = document.querySelector('.institute')

  const YOffset = window.pageYOffset
  const topPosition = apiResultsElement.getBoundingClientRect().top + window.scrollY
  const bottomPosition = footerElement.getBoundingClientRect().top + window.scrollY

  console.log(instituteElement.clientHeight)
  if (YOffset < topPosition) {
    window.scrollBy(0, topPosition - YOffset)
  }
}

const addInstituteCodeToUrl = (instituteCode, justRemove) => {

  let search = decodeURI(location.search)
  const regex = /institute=[0-9]+/
  const found = search.match(regex)

  if (instituteCode) {


    if (found) {
      search = search.replace(regex, `institute=${instituteCode}`)
    } else {
      search += `institute=${instituteCode}`
    }

    history.pushState(null, null, search)

  } else if (justRemove && found) {
    search = search.replace(regex, '')
    history.pushState(null, null, search)
  }
}

export const closeInstitute = () => {
  apiResultsElement.style.visibility = 'visible'
  loadMoreBtn.style.display = 'block'
  instituteElement.classList.remove('institute--active')
  bodyElement.classList.remove('no-scroll')

  // remove institute from url
  addInstituteCodeToUrl(null, true)
}

